import { useTranslation } from 'react-i18next';
import { Buildings, ArrowUp } from '@phosphor-icons/react';

/**
 * Shown to admins on client-scoped pages while no acting client is selected
 * in the header dropdown. Pages render this instead of fetching data.
 */
export default function SelectClientPrompt() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-24 px-4 text-center">
      <div className="w-14 h-14 rounded-full bg-primary-50 flex items-center justify-center mb-4">
        <Buildings className="w-7 h-7 text-primary-500" weight="light" />
      </div>
      <h2 className="text-lg font-semibold text-slate-800 mb-1">
        {t('nav.selectClientPromptTitle')}
      </h2>
      <p className="text-sm text-slate-500 max-w-sm flex items-center gap-1.5 justify-center">
        <ArrowUp className="w-4 h-4 shrink-0" weight="light" />
        {t('nav.selectClientPromptBody')}
      </p>
    </div>
  );
}
